// export default Dashboard;

import React, { useEffect } from "react";
import "../../styles/dashboard.css";
import Content from "../Content/content";
import Navbar from "../NavBar/Navbar";
import Menubar from "../sidebarFolder/menubar";


import { useDispatch, useSelector } from "react-redux";
import { AccessTockenReducer } from "../../Redux/store";
// import StickyFooter from "../NavBar/footer";

function Dashboard(props) {
  //useEffect hook
  const dispatch = useDispatch();
  const toggled = useSelector((state) => state.AccessTocken.sidebarToggle);
  // const [toggled, setToggled] = useState(false);
  useEffect(() => { });
  const handleToggleSidebar = (toggled) => {
    dispatch(AccessTockenReducer.sidebar_toggle(toggled ? true : false));
    //setToggled(value);
  };

  return (
    <div className={`app  ${toggled ? "toggled" : ""}`}>
      <Menubar toggled={toggled} handleToggleSidebar={handleToggleSidebar} />
      <main>
        <Navbar handleToggleSidebar={handleToggleSidebar} />
        <div className="app-content">
          <Content />
        </div>
      </main>
    </div>
  );
}

export default Dashboard;
